(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-demo-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('home-demo-reviews')) {
  customElements.define('home-demo-reviews', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-reviews-viewport]');
      this.cards = Array.from(this.querySelectorAll('.home-demo-reviews__card'));
      this.previousButton = this.querySelector('[data-reviews-previous]');
      this.nextButton = this.querySelector('[data-reviews-next]');
      this.toggleButton = this.querySelector('[data-reviews-toggle]');
      this.count = this.querySelector('[data-reviews-count]');
      if (!this.viewport || !this.cards.length || !this.previousButton || !this.nextButton || !this.toggleButton || !this.count) return;

      this.manualPaused = false;
      this.hasFocus = false;
      this.isVisible = !('IntersectionObserver' in window);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.handleScroll = () => {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateControls());
      };
      this.handlePrevious = () => {
        this.move(-1);
        this.syncAutoplay();
      };
      this.handleNext = () => {
        this.move(1);
        this.syncAutoplay();
      };
      this.handleToggle = () => {
        if (this.reducedMotion) return;
        this.manualPaused = !this.manualPaused;
        this.updateToggle();
        this.syncAutoplay();
      };
      this.handleFocusIn = () => {
        this.hasFocus = true;
        this.syncAutoplay();
      };
      this.handleFocusOut = () => {
        requestAnimationFrame(() => {
          this.hasFocus = this.contains(document.activeElement);
          this.syncAutoplay();
        });
      };
      this.handleVisibilityChange = () => this.syncAutoplay();

      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);
      this.toggleButton.addEventListener('click', this.handleToggle);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.isVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio > 0.15);
          this.syncAutoplay();
        }, { threshold: [0, 0.15] });
        this.visibilityObserver.observe(this.closest('.home-demo-reviews') || this);
      }

      this.updateToggle();
      this.updateControls();
      this.syncAutoplay();
    }

    disconnectedCallback() {
      if (this.viewport) this.viewport.removeEventListener('scroll', this.handleScroll);
      if (this.previousButton) this.previousButton.removeEventListener('click', this.handlePrevious);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      if (this.toggleButton) this.toggleButton.removeEventListener('click', this.handleToggle);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
      if (this.autoplayTimer) clearTimeout(this.autoplayTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    }

    syncAutoplay() {
      if (this.autoplayTimer) clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
      if (this.manualPaused || this.hasFocus || !this.isVisible || this.reducedMotion || document.hidden) return;
      this.autoplayTimer = setTimeout(() => {
        this.autoplayTimer = null;
        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        if (this.viewport.scrollLeft >= maxScroll - 1) {
          this.viewport.scrollTo({ left: 0, behavior: 'auto' });
          this.updateControls();
        } else {
          this.move(1);
        }
        this.syncAutoplay();
      }, 2000);
    }

    updateToggle() {
      if (this.reducedMotion) {
        this.toggleButton.disabled = true;
        this.toggleButton.textContent = 'Défilement désactivé';
        this.toggleButton.setAttribute('aria-label', 'Défilement automatique désactivé selon vos préférences');
        this.toggleButton.setAttribute('aria-pressed', 'true');
        return;
      }
      this.toggleButton.disabled = false;
      this.toggleButton.textContent = this.manualPaused ? 'Reprendre' : 'Pause';
      this.toggleButton.setAttribute('aria-label', this.manualPaused ? 'Reprendre le défilement automatique' : 'Mettre les avis en pause');
      this.toggleButton.setAttribute('aria-pressed', String(this.manualPaused));
    }

    move(direction) {
      const currentLeft = this.viewport.scrollLeft;
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      if (maxScroll > 1 && direction > 0 && currentLeft >= maxScroll - 1) {
        this.viewport.scrollTo({ left: 0, behavior: 'auto' });
        this.updateControls();
        return;
      }
      if (maxScroll > 1 && direction < 0 && currentLeft <= 1) {
        this.viewport.scrollTo({ left: maxScroll, behavior: 'auto' });
        this.updateControls();
        return;
      }
      let currentIndex = 0;
      let smallestDistance = Infinity;
      this.cards.forEach((card, index) => {
        const left = card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + currentLeft;
        const distance = Math.abs(left - currentLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          currentIndex = index;
        }
      });
      const targetIndex = Math.max(0, Math.min(this.cards.length - 1, currentIndex + direction));
      const targetLeft = this.cards[targetIndex].getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + currentLeft;
      this.viewport.scrollTo({ left: targetLeft, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    updateControls() {
      if (!this.viewport) return;
      const viewportBounds = this.viewport.getBoundingClientRect();
      const visibleCards = this.cards.filter(card => {
        const bounds = card.getBoundingClientRect();
        return bounds.right > viewportBounds.left + 1 && bounds.left < viewportBounds.right - 1;
      });
      const firstVisible = this.cards.indexOf(visibleCards[0]);
      const lastVisible = this.cards.indexOf(visibleCards[visibleCards.length - 1]);
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const canScroll = maxScroll > 1;
      this.previousButton.disabled = !canScroll;
      this.nextButton.disabled = !canScroll;
      if (firstVisible >= 0 && lastVisible >= firstVisible) {
        this.count.textContent = firstVisible === lastVisible
          ? 'Avis ' + (firstVisible + 1) + ' sur ' + this.cards.length
          : 'Avis ' + (firstVisible + 1) + ' à ' + (lastVisible + 1) + ' sur ' + this.cards.length;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-trust"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pet-duo-offers')) {
  customElements.define('pet-duo-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.duoController) return;
      this.duoController = new AbortController();
      const signal = this.duoController.signal;
      const money = new Intl.NumberFormat(this.dataset.locale || 'fr', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-duo-variant]')) return;
        const form = event.target.closest('form');
        const prices = Array.from(form.querySelectorAll('[data-duo-variant]')).map(select => Number(select.selectedOptions[0]?.dataset.price || 0));
        const total = prices.reduce((sum, price) => sum + price, 0);
        const savings = prices.reduce((sum, price) => sum + Math.floor(price * Number(form.dataset.discount) / 100), 0);
        form.querySelector('[data-duo-total]').textContent = money.format((total - savings) / 100);
        form.querySelector('[data-duo-original]').textContent = money.format(total / 100);
        form.querySelector('[data-duo-saving]').textContent = money.format(savings / 100);
      }, { signal });
      this.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!form.matches('.pet-offers__form')) return;
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (button.disabled) return;
        const status = form.querySelector('[role="status"]');
        const items = Array.from(form.querySelectorAll('[data-duo-variant]')).map(select => ({ id: Number(select.value), quantity: 1 }));
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.textContent = 'Ajout des deux articles…';
        try {
          const response = await fetch(form.action + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Un article n’est plus disponible. Vérifiez les modèles choisis.');
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          status.textContent = error instanceof Error ? error.message : 'Ajout impossible. Réessayez ou contactez-nous.';
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.duoController?.abort();
      this.duoController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
